module.exports = __webpack_public_path__ + "img/research_1.3afa2035.jpg";